import { useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

/**
 * PWAUpdateToast — shows a small bottom toast when a new service worker is
 * waiting. Clicking "Refresh" activates the new SW and reloads the page.
 * Registers the service worker (registerType: 'prompt'). Never renders in dev.
 */
const PWAUpdateToast = () => {
  const [dismissed, setDismissed] = useState(false);

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      // Non-fatal — the app works without a SW
      console.warn('SW registration failed:', error);
    },
  });

  // Never render in dev; the SW is only generated for production builds
  if (import.meta.env.DEV) return null;
  if (!needRefresh || dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    setNeedRefresh(false);
  };

  return (
    <div
      role="alert"
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[110] flex items-center gap-3 px-4 py-3 rounded-xl shadow-lg border bg-white border-slate-200 text-slate-800 dark:bg-dark-800 dark:border-dark-700 dark:text-slate-100"
    >
      <span className="text-sm font-medium whitespace-nowrap">New version available</span>
      <button
        type="button"
        onClick={() => updateServiceWorker(true)}
        className="px-3 py-1.5 rounded-lg text-sm font-semibold text-white bg-gradient-to-r from-pink-500 to-violet-600 hover:opacity-90 transition-opacity"
      >
        Refresh
      </button>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss update notification"
        className="p-1 rounded-md text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300 transition-colors"
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};

export default PWAUpdateToast;
